/**
 * Spec 034: the pair that leads a task, in words for its card. Pure, so the node tests
 * read it without React: who leads, whether their agent is working (it acted on the task
 * in the last 15 minutes, as the server decides) and what an open request waits for.
 */
import type { TaskLeadOut, TaskOpenRequestOut } from "@/api/types";

/** «12:40» today, «5 окт., 12:40» another day — the device's clock. */
export function clock(iso: string, now: Date = new Date()): string {
  const at = new Date(iso);
  const time = at.toLocaleTimeString("ru-RU", { hour: "2-digit", minute: "2-digit" });
  if (at.toDateString() === now.toDateString()) return time;
  return `${at.toLocaleDateString("ru-RU", { day: "numeric", month: "short" })}, ${time}`;
}

/** The agent's state: «работает» or «состояние неизвестно, последнее действие …». */
export function agentState(lead: TaskLeadOut, now: Date = new Date()): string | null {
  if (!lead.agent) return null;
  if (lead.agent.working) return `агент «${lead.agent.name}» работает`;
  return `агент «${lead.agent.name}»: состояние неизвестно, последнее действие ${clock(lead.agent.last_action_at, now)}`;
}

/** One open request as a line of the card. */
export function requestLine(request: TaskOpenRequestOut): string {
  const what = request.kind === "handover"
    ? `${request.addressee_name}: принять задачу`
    : `${request.addressee_name}: ${request.action}`;
  const personal = request.kind === "ask" && request.mode === "personal" ? " · личный ответ" : "";
  const stands = request.blocking ? ` · стоит: ${request.blocking_note ?? "работа ждёт ответа"}` : "";
  return `${what}${personal}${stands}`;
}
